import differenceInHours from 'date-fns/differenceInHours';
import { type StorageData, getDataFromStorage, saveDataToStorage } from 'reactApp/storage';

export const is24HoursPassed = (startTime: number) => {
    if (startTime === 0) {
        return true;
    }

    const currDate = new Date().valueOf();
    const diffDays = Math.trunc(differenceInHours(currDate, startTime) / 24) || 0;

    return diffDays >= 1;
};

const promoPopupId = 'ai_improve_ppp_before_publish';
const MaxShowPromoPopupCount = 3;
const showInterval = 172800;

export const getCanBeShownAiPromoBeforePublish = () => {
    const data = getDataFromStorage(promoPopupId);
    const count = data?.counts?.show || 0;

    const lastShowTime = data?.time || 0;

    const currentTime = Math.floor(new Date().getTime() / 1000);

    const isCanShowByTime = currentTime - showInterval > lastShowTime;

    if (count >= MaxShowPromoPopupCount || !isCanShowByTime) {
        return false;
    }

    return () => saveDataToStorage<StorageData>(promoPopupId, { counts: { show: count + 1 }, time: currentTime });
};
